import React from 'react';
import { useBackgroundMusic } from '../utils/audio';

const SoundOnIcon = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
    <path d="M11 2H9v2H7v2H5v2H1v8h4v2h2v2h2v2h2V2zM7 18v-2H5v-2H3v-4h2V8h2V6h2v12H7zm6-8h2v4h-2v-4zm8-6h-2V2h-6v2h6v2h2v12h-2v2h-6v2h6v-2h2v-2h2V6h-2V4zm-2 4h-2V6h-4v2h4v8h-4v2h4v-2h2V8z" fill="currentColor"/>
  </svg>
);

const SoundOffIcon = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
    <path d="M13 2h-2v2H9v2H7v2H3v8h4v2h2v2h2v2h2V2zM9 18v-2H7v-2H5v-4h2V8h2V6h2v12H9zm10-6.777h-2v-2h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2zm0 0h2v-2h-2v2z" fill="currentColor"/>
  </svg>
);

export default function MusicPlayer() {
  const { isPlaying, togglePlay } = useBackgroundMusic();

  return (
    <button
      onClick={togglePlay}
      className={`nes-btn is-small ${isPlaying ? 'is-success' : 'is-error'}`}
      aria-label={isPlaying ? 'Mute music' : 'Play music'}
      title={isPlaying ? 'Mute music' : 'Play music'}
      style={{ 
        minWidth: '48px',
        width: '48px',
        height: '48px',
        padding: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {isPlaying ? <SoundOnIcon /> : <SoundOffIcon />}
    </button>
  );
} 